
import { oz } from '@weft/utils';
import { withNullAsOptional } from '../../utils/literal-transforms';
import { NewProductSchema } from '../product';
import { NewProductVariantSchema, withUsageProductMeterIdValidation } from '../product-variant';
import { NewPromotionSchema } from '../promotion';
import { PlanBillingDataSchema } from './plan-billing-data-schema';
import { PlanStatusSchema } from './plan-status-schema';
import { TrialDurationSchema } from './trial-duration-schema';

const RefinedNewProductSchema = NewProductSchema.extend({
  variants: oz.array(withUsageProductMeterIdValidation(NewProductVariantSchema)).min(1),
});

export const NewPlanSchema = oz.object({
  name: oz.string().nonempty('Plan name is required'),
  description: withNullAsOptional(oz.string().nonempty()),
  products: oz.array(RefinedNewProductSchema).min(1, 'At least one product is required'),
  promotions: oz.array(NewPromotionSchema).optional(),
  billingData: PlanBillingDataSchema,
  status: PlanStatusSchema,
  basedFromPlanId: withNullAsOptional(oz.string()),
  trial: withNullAsOptional(TrialDurationSchema),
}).openapi('NewPlan');

export type NewPlan = oz.infer<typeof NewPlanSchema>;